export default "__VITE_ASSET__B6tRcJ10__"